<template>
  <v-card flat class="dialog" color="grey ">
    <v-toolbar color="" outlined>
      <v-btn icon @click="$emit('fechar')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>Meus modelos</v-toolbar-title>
    </v-toolbar>

    <v-tabs v-model="tab" grow background-color="grey darken-1" color="white">
      <v-tab>Laudo/Prontuário</v-tab>
      <v-tab>Modelos de Frases</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <!-- Tab 1: Laudo/Prontuário -->
      <v-tab-item>
        <v-card-text>
          <div v-if="user.servicosEscolhidos">
            <v-autocomplete class="pa-2" solo dense v-model="servicoSelecionado" item-value="idServico" no-data-text="Nenhum serviço disponível" :items="user.servicosEscolhidos" item-text="nomeEspecialidade" label="Serviço" hint="Escolha um serviço" persistent-hint></v-autocomplete>
            <v-autocomplete class="pa-2" solo dense :loading="loadExame" :disabled="!servicoSelecionado" v-model="exameSelecionado" return-object no-data-text="Nenhum exame disponivel" :items="exames" item-text="nomeExame" label="Exame" hint="Escolha um serviço" persistent-hint></v-autocomplete>
          </div>
          <div v-else>
            <v-alert dark icon="fas fa-user-md" border="left" prominent color="primary" class="pa-2 mx-2">Configure o local de atendimento para poder selecionar os exames</v-alert>
          </div>
          <v-select :disabled="exameSelecionado" :loading="loadModelos" solo class="pa-2" :items="modelos" item-text="titulo" return-object v-model="modelo" outlined label="Selecionar modelo" dense></v-select>
        </v-card-text>
        <v-card class="mx-6">
          <v-text-field v-model="titulo" label="Titulo" outlined class="mx-2 pt-2"></v-text-field>
          <tiptap-vuetify :card-props="{ flat: true }" v-model="content" :extensions="extensions" placeholder="Descrição …" />
        </v-card>
        <v-card-actions class="mx-2">
          <v-chip v-if="modelo" class="ma-2" color="primary" label>
            <v-icon left>mdi-label</v-icon>
            {{ modelo.nomeExame }}
          </v-chip>
          <v-spacer />
          <v-btn color="blue-grey" text @click="limpar">
            Limpar
            <v-icon right dark>clear</v-icon>
          </v-btn>
          <v-btn :loading="load" :disabled="content == '' || titulo == ''" depressed :color="idModelo == '' ? 'primary' : 'orange'" v-text="idModelo == '' ? 'Cadastrar' : 'Editar'" @click="cadastrarModeloProntuario"></v-btn>
        </v-card-actions>
      </v-tab-item>

      <!-- Tab 2: Modelos de Frases -->
      <v-tab-item>
        <v-card-text>
          <v-text-field v-model="novaFrase" label="Nova Frase" outlined class="mx-2 pt-2"></v-text-field>
          <v-btn color="primary" @click="adicionarFrase">Adicionar Frase</v-btn>
          <v-list>
            <v-list-item v-for="(frase, index) in frases" :key="index">
              <v-list-item-content>
                <v-list-item-title>{{ frase }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click="removerFrase(index)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import medicoService from '../../services/medico.service'
import 'tiptap-vuetify/dist/main.css'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History
} from 'tiptap-vuetify'

export default {
  components: {
    TiptapVuetify
  },

  data: () => ({
    tab: 0, // Controla a aba ativa
    user: '',
    content: '',
    modelo: '',
    servicoSelecionado: null,
    exameSelecionado: null,
    titulo: '',
    idModelo: '',
    tipo: 'LAUDO',
    msg: '',
    loadModelos: false,
    modelos: [],
    servicosMedico: [],
    loadExame: false,
    exames: [],
    load: false,
    novaFrase: '', // Nova frase para adicionar
    frases: [], // Lista de frases cadastradas
    extensions: [
      History,
      Blockquote,
      Link,
      Underline,
      Strike,
      Italic,
      ListItem,
      BulletList,
      OrderedList,
      [Heading, {
        options: {
          levels: [1, 2, 3]
        }
      }],
      Bold,
      Code,
      HorizontalRule,
      Paragraph,
      HardBreak
    ]
  }),

  methods: {
    limpar () {
      this.content = ''
      this.titulo = ''
      this.idModelo = ''
      this.modelo = ''
      this.exameSelecionado = null
      this.servicoSelecionado = null
    },
    listarExamesPorEspecialidade () {
      this.loadExame = true
      medicoService.medico.listarExamesPorEspecialidade(this.servicoSelecionado).then(r => {
        if (r.status == 200) {
          this.exames = r.data
          this.loadExame = false
        }
      })
    },
    cadastrarModeloProntuario () {
      this.load = true
      medicoService.medico.cadastrarModeloProntuario(this.user.id, this.titulo, this.content, this.tipo, this.idModelo,
        this.modelo ? this.modelo.idExame : this.exameSelecionado ? this.exameSelecionado.idExame : '',
        this.modelo ? this.modelo.nomeExame : this.exameSelecionado ? this.exameSelecionado.nomeExame : '').then(r => {
        if (r.status == 200) {
          this.msg = r.data.msg
          this.limpar()
        }
      }).finally(() => {
        this.load = false
        this.limpar()
        this.listarModelosProntuario()
      })
    },
    listarModelosProntuario () {
      this.loadModelos = true
      medicoService.medico.listarModelosProntuario(this.tipo, this.user.id, '').then(r => {
        if (r.status == 200) {
          if (r.data.status == 'error') {
            this.msg = r.data.msg
          } else {
            this.modelos = r.data
          }
        }
      }).finally(() => {
        this.loadModelos = false
      })
    },
    adicionarFrase () {
      if (this.novaFrase.trim() !== '') {
        this.frases.push(this.novaFrase)
        this.novaFrase = ''
      }
    },
    removerFrase (index) {
      this.frases.splice(index, 1)
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario
    this.listarModelosProntuario()
  },
  watch: {
    modelo (val) {
      if (val != '') {
        this.idModelo = val._id
        this.titulo = val.titulo
        this.content = val.descricao
      }
    },
    servicoSelecionado (val) {
      if (this.servicoSelecionado != null) {
        this.listarExamesPorEspecialidade()
      }
    },
    exameSelecionado (val) {
      if (this.exameSelecionado != null) {
        this.modelo = null
        this.idModelo = ''
        this.titulo = ''
        this.content = ''
      }
    },
    tipo (val) {
      this.limpar()
      this.listarModelosProntuario()
    }
  }
}
</script>

<style scoped>
.grey darken-1  color="white">{
  background-color: #FFFBE6 !important;
}
</style>
